<template>
	<transition :name='tabChangeDirection == "left" ? "tabs-right-to-left" : "tabs-left-to-right"'>
		<div class='tab' v-show='true || visable' v-bind='$attrs'>
			<slot />
		</div>
	</transition>
</template>

<script>
	export default {
		inheritAttrs: false,

		props: {
			visable: Boolean,
			tabChangeDirection: String
		}
	}
</script>